// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2W24I","col":"styles_col__2K73a"};